export default __webpack_public_path__ + "static/media/unbindIcon.4cdb8ddc.svg";